var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"normal-btn-text rounded-tag-small elevation-0",attrs:{"color":_vm.btnColor},on:{"click":_vm.onClickConectar}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }